import SectionWrapper from '@/components/Landing/SectionWrapper'
import { useEffect, useState } from 'react'

const StepItem = ({ index, children }: { index: number; children: React.ReactNode }) => {
  return (
    <div className="!font-libre-baskerville flex flex-col text-[24px] leading-none text-white">
      <span className="!font-libre-baskerville mb-2 text-[32px]">
        {index.toString().padStart(2, '0')}
      </span>
      {children}
    </div>
  )
}

const Step = () => {
  const [isPortrait, setIsPortrait] = useState(false)

  useEffect(() => {
    const checkOrientation = () => {
      setIsPortrait(window.innerHeight > window.innerWidth)
    }

    // Check on initial load
    checkOrientation()

    // Listen for resize events
    window.addEventListener('resize', checkOrientation)

    // Cleanup event listener
    return () => window.removeEventListener('resize', checkOrientation)
  }, [])

  const backgroundUrl = isPortrait
    ? 'https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low/v1745315361/Image_nldhxg.jpg'
    : 'https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low/v1745956073/Wizards_Gaze_at_Mystical_Vortex_dpiwu0.png'

  return (
    <SectionWrapper
      className="container mx-auto max-w-[95%] overflow-clip rounded-2xl bg-center px-5 py-16 text-white"
      title={
        <>
          Creativity is the limit. <br /> Not the technology.
        </>
      }
      backgroundUrl={backgroundUrl}
    >
      <div className="mt-[200px] flex flex-col items-start justify-around gap-10 px-2 md:flex-row md:gap-12 md:px-10">
        <StepItem index={1}>
          <p className="max-w-[200px]">
            Describe the app you want to build or start from a template
          </p>
        </StepItem>
        <StepItem index={2}>
          <p className="max-w-[200px]">Chat with Sprites Copilot to refine it to your vision</p>
        </StepItem>
        <StepItem index={3}>
          <p className="max-w-[200px]">Share the app with your team, customers, or friends</p>
        </StepItem>
      </div>
    </SectionWrapper>
  )
}

export default Step
